import { render, staticRenderFns } from "./FiscalCode.vue?vue&type=template&id=24f3cd15&"
import script from "./FiscalCode.vue?vue&type=script&lang=js&"
export * from "./FiscalCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports